export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">
              黑料每日大赛
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              每日更新最新爆料，汇聚全网今日黑料、吃瓜事件与最新黑料合集。黑料每日大赛致力于速递全网热门黑料，满足每一位吃瓜群众的每日需求。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-sm text-background-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '话题热榜', href: '#topics' },
                { label: '常见问答', href: '#faq' },
                { label: '瓜友热评', href: '#comments' },
                { label: '黑料排行', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-medium text-sm text-background-200 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">暂无合作伙伴信息</p>
          </div>

          <div>
            <h4 className="font-medium text-sm text-background-200 mb-4">关注我们</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              每日新鲜爆料，扫码或搜索「黑料每日大赛」关注我们的社交媒体账号，不错过任何一条热门黑料。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 黑料每日大赛 - 吃瓜第一站。本站内容来源于网络公开信息，仅供娱乐参考。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap no-underline cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap no-underline cursor-pointer">免责声明</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap no-underline cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}